import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "app-date-string-picker" }
const _hoisted_2 = { class: "app-date-string-picker__default-trigger-date" }

import {
	ref,
	computed,
	watch
} from 'vue'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";

type Props = {
	modelValue?: Date | null
	format?: string
	locale?: string
	minDate?: Date
	maxDate?: Date
	autoApply?: boolean
	placeholder?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppDateString',
  props: {
    modelValue: { default: null },
    format: { default: 'dd.MM.yyyy' },
    locale: { default: 'ru' },
    minDate: { default: undefined },
    maxDate: { default: undefined },
    autoApply: { type: Boolean, default: true },
    placeholder: { default: '' }
  },
  emits: ["update:modelValue", "select", "open", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const selectedDate = ref<Date | null>(props.modelValue)
const isOpen = ref(false)
const triggerRef = ref<HTMLElement | null>(null)

const formattedDate = computed(() => {
	if (!selectedDate.value) return null
	return selectedDate.value.toLocaleDateString('ru-RU', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric'
	})
})

const minDate = computed(() => {
	if (props.minDate) return props.minDate
	const today = new Date()
	today.setHours(0, 0, 0, 0)
	return today
})

const dropdownStyles = computed(() => {
	if (!triggerRef.value) return {}

	const rect = triggerRef.value.getBoundingClientRect()
	return {
		position: 'fixed',
		top: rect.bottom + 4 + 'px',
		left: rect.left + 'px',
		zIndex: 9999
	}
})

const openPicker = () => {
	isOpen.value = true
	emit('open')
}

const handleDateSelect = (date: Date | null) => {
	selectedDate.value = date
	emit('update:modelValue', date)
	emit('select', date)
	isOpen.value = false
	emit('close')
}

const onPickerOpen = () => {
}

const onPickerClose = () => {
	isOpen.value = false
	emit('close')
}

const handleClickOutside = () => {
	isOpen.value = false
	emit('close')
}

watch(() => props.modelValue, (newVal) => {
	selectedDate.value = newVal
})

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "triggerRef",
      ref: triggerRef,
      class: "app-date-string-picker__trigger",
      onClick: openPicker
    }, [
      _renderSlot(_ctx.$slots, "trigger", {
        date: selectedDate.value,
        formatted: formattedDate.value,
        open: openPicker
      }, () => [
        _createElementVNode("div", {
          class: _normalizeClass({
						'app-date-string-picker__default-trigger': true,
						'app-date-string-picker__default-trigger--date-selected': !!selectedDate.value,
					})
        }, [
          _createVNode(AppIcon, {
            class: "app-date-string-picker__default-trigger-icon",
            name: "clock",
            width: "18px",
            color: "#979797"
          }),
          _createElementVNode("div", _hoisted_2, _toDisplayString(formattedDate.value || _ctx.placeholder || _ctx.$t("ui_date_placeholder")), 1)
        ], 2)
      ])
    ], 512),
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "app-date-string-picker__dropdown",
          style: _normalizeStyle(dropdownStyles.value)
        }, [
          _createVNode(_unref(VueDatePicker), {
            ref: "pickerRef",
            modelValue: selectedDate.value,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((selectedDate).value = $event)),
              handleDateSelect
            ],
            format: _ctx.format,
            locale: _ctx.locale,
            "enable-time-picker": false,
            "min-date": minDate.value,
            "max-date": _ctx.maxDate,
            "auto-apply": _ctx.autoApply,
            onOpen: onPickerOpen,
            onClose: onPickerClose,
            teleport: false,
            inline: true
          }, null, 8, ["modelValue", "format", "locale", "min-date", "max-date", "auto-apply"])
        ], 4))
      : _createCommentVNode("", true)
  ])), [
    [_directive_click_outside, handleClickOutside]
  ])
}
}

})